import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Header } from '../Header/Header';
import { Menu } from '../Menu/Menu';
import * as Styled from './GlobalNavigation.style';
import { useAuth } from '../../../context/AuthContext';
// --- MOCKS ---
const toggleHighContrast = () => {
    document.documentElement.classList.toggle('inverted');
};
const ACCESSIBILITY_ITEMS = [
    { label: 'Aumentar fonte', onClick: () => console.log('Aumentar fonte') },
    { label: 'Diminuir fonte', onClick: () => console.log('Diminuir fonte') },
    { label: 'Alto contraste', onClick: toggleHighContrast },
];
const USER_MENU_ITEMS = [
    { label: 'Meu perfil', path: 'https://amei.sebrae.com.br/auth/realms/externo/account', targetBlank: true },
    { label: 'Central de ajuda', path: '/help-center' },
    { label: 'Tour de apresentação', path: '/' }
];
export const MENU_ITEMS = [
    { name: "Meus Cursos", path: "/my-courses", targetBlank: false },
    { name: "Histórico", path: "/history", targetBlank: false },
    { name: "Catálogo de Cursos", path: "https://loja.sebrae.com.br/", targetBlank: true },
    { name: "E-books e Jogos", path: "/digital-media", targetBlank: false },
    { name: "Meus Certificados", path: "https://certificados.sebrae.com.br/certificados", targetBlank: true },
    { name: "Central de Ajuda", path: "/help-center", targetBlank: false }
];
const MOCK_SEARCH_PROPS = {
    placeholder: "Buscar por palavra-chave"
};
export const GlobalNavigation = () => {
    const { user, logout } = useAuth();
    const headerUser = user ? {
        name: user.name,
        email: user.email,
        avatarUrl: user.picture || user.avatar || ''
    } : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(Styled.HeaderContainer, { children: _jsx(Header, { user: headerUser, accessibilityItems: ACCESSIBILITY_ITEMS, userMenuItems: USER_MENU_ITEMS, menuItems: MENU_ITEMS, searchProps: MOCK_SEARCH_PROPS, onLogout: logout }) }), _jsx(Styled.MenuContainer, { children: _jsx(Menu, { items: MENU_ITEMS }) })] }));
};
//# sourceMappingURL=GlobalNavigation.js.map